import { render, staticRenderFns } from "./AnnualUserStatistics.vue?vue&type=template&id=38bc7b26&"
import script from "./AnnualUserStatistics.vue?vue&type=script&lang=js&"
export * from "./AnnualUserStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports